import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import VueMq from 'vue-mq';
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';
import 'vuejs-google-maps/dist/vuejs-google-maps.css';

import i18n from './i18n';

import VueProgressiveImage from 'vue-progressive-image';
// import VueProgressBar from 'vue-progressbar';
import VueYoutube from 'vue-youtube';
import VeeValidate from 'vee-validate';
//import VueAnalytics from 'vue-analytics';
import VueMeta from 'vue-meta';
import VueGAPI from 'vue-gapi';
import VueClipboard from 'vue-clipboard2';
import Viewer from 'v-viewer';
import Toast from 'vue-toastification';

import LogRocket from 'logrocket';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

//import VueGoogleMap from 'vuejs-google-maps';
import VueCookies from 'vue-cookies';

import './registerServiceWorker';

import VCalendar from 'v-calendar';

import 'vue-swatches/dist/vue-swatches.css';

import VueGtag from 'vue-gtag';

//import CookiesConsent from 'vuejs-cookies-consent';

import VueSocialSharing from 'vue-social-sharing'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import JsonCSV from 'vue-json-csv'

import vSelect from 'vue-select'
//import 'vue-select/dist/vue-select.css';
import Multiselect from 'vue-multiselect'

Vue.component('multiselect', Multiselect)

Vue.component('downloadCsv', JsonCSV)

//Vue.component('v-select', vSelect)

library.add(fab);
Vue.component('font-awesome-icon', FontAwesomeIcon);

//import infiniteScroll from 'vue-infinite-scroll'

const isDev = process.env.NODE_ENV !== 'production';
Vue.config.performance = false;
Vue.config.productionTip = false;
Vue.use(VeeValidate);
Vue.use(VueYoutube);
Vue.use(VueProgressiveImage);
/*Vue.use(VueProgressBar, {
    color: '#0069bb',
    failedColor: 'red',
    thickness: '5px',
});*/
Vue.use(VueMq, {
    breakpoints: {
        // default breakpoints - customize this
        mobile: 767,
        tablet: 1023,
        desktop: 1039,
    },
});
/*Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_ID_GOOGLE_ANALYTICS,
    router,
    ignoreRoutes: ['login'],
    autoTracking: {
        //screenview: true,
    },
});*/

Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_ID_GOOGLE_ANALYTICS },
    bootstrap: false
});

Vue.use(VueMeta, {
    // optional pluginOptions
    refreshOnceOnNavigation: true,
});
Vue.use(VuePlyr);
Vue.use(VueGAPI, {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    scope: 'email profile openid',
    prompt: 'select_account',
    include_granted_scopes: true,
    discoveryDocs: [
        'https://www.googleapis.com/discovery/v1/apis/classroom/v1/rest',
    ],
    redirect_uri: process.env.VUE_APP_GOOGLE_REDIRECT_URI,
});

Vue.use(VueClipboard);
Vue.use(Viewer, {
    defaultOptions: {
        button: false,
        navbar: false,
        title: false,
        toolbar: {
            zoomIn: true,
            zoomOut: true,
            oneToOne: true,
            reset: true,
            prev: false,
            play: false,
            next: false,
            rotateLeft: false,
            rotateRight: false,
            flipHorizontal: false,
            flipVertical: false,
        },
    },
});
Vue.use(Toast);

/*Vue.use(VueGoogleMap, {
    load: {
        apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
        libraries: ['places', 'visualization'],
    },
});*/
Vue.use(VueCookies);

Vue.use(VCalendar, {
    componentPrefix: 'vc',
});

//Vue.use(CookiesConsent);

Vue.use(VueSocialSharing);

//Vue.use(infiniteScroll)

const app = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');

if (isDev) {
    /*LogRocket.init('ypcrl7/labygram');
    LogRocket.getSessionURL(function (sessionURL) {
        app.$ga.event('send', {
            hitType: 'event',
            eventCategory: 'LogRocket',
            eventAction: sessionURL,
        });
    });
    Sentry.init({
        Vue,
        dsn: 'https://8d4c79d606c14e23ab68d21451e87c2c@o524503.ingest.sentry.io/5637245',
        integrations: [new Integrations.BrowserTracing()],
        logErrors: true,
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
    });*/
}
